import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';

export function GlobalStyle() {
  return <CssBaseline />;
}
